// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    font-family: Arial, Helvetica, sans-serif !important;
}



.rowcenter {
    margin-top: 30px;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    width: 100%;
    flex-direction: row;
  }
  
  
  .dropzone-container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 40%;
  }

  @media screen and (max-width: 600px) {
    .dropzone-container { 
      width: 48%;
    }
   
  }
  
  .dropzone {
    width: 90%;
    /* min-width: 250px; */
    cursor: pointer;
    /* height: 220px; */
    padding: 1rem;
    text-align: center;
    border-radius: 20px;
    border: dashed 1px #979797;
    position: relative;
    margin: 0 auto;
    box-shadow: 1px 1px 2px rgba(255, 255, 255, .6)
  }
  
  
  
  
  .dropzone input {
    opacity: 0;
    position: absolute;
    z-index: 2;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    cursor: pointer;
  }
  
  ul {
    padding: 0px;
    margin: 0px;
  }
  
  .dropzone label {
    color: white;
    background-image: linear-gradient(to right, #77A1D3, #79CBCA );
    height: 32px;
    width: 150px;
    border-radius: 20px;
    padding: 4px 8px;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 2px 0px;
  }
  
  .dropzone h5 {
    color: #aaabad;
    font-weight: 700;
  }
  
  
  .fileover {
    animation: shake 1s;
    animation-iteration-count:infinite;
  }
  
  .file-list {
    width: 80%;
    display: flex;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-top: 15px;
    border-radius: 10px;
    padding: 5px
  }
  
  
  .name {
    font-size: 14px;
    font-weight: 500;
    color: #353f4a;
    margin: 0;
  }
  
  .size {
    font-size: 12px;
    font-weight: 500;
    color: #a4a4a4;
    margin: 0;
    margin-bottom: 0.25rem;
  }
  
  .info {
    width: 100%
  }
  
  @keyframes extend {
    0% {width: 75%}
    100% {width: 90%}
  }
  
  @keyframes shake {
    0% {
      transform: translate(1px, 1px) rotate(0deg);
    }
  
    10% {
      transform: translate(-1px, -2px) rotate(-1deg);
    }
  
    20% {
      transform: translate(-3px, 0px) rotate(1deg);
    }
  
    30% {
      transform: translate(3px, 2px) rotate(0deg);
    }
  
    40% {
      transform: translate(1px, -1px) rotate(1deg);
    }
  
    50% {
      transform: translate(-1px, 2px) rotate(-1deg);
    }
  
    60% {
      transform: translate(-3px, 1px) rotate(0deg);
    }
  
    70% {
      transform: translate(3px, 1px) rotate(-1deg);
    }
  
    80% {
      transform: translate(-1px, -1px) rotate(1deg);
    }
  
    90% {
      transform: translate(1px, 2px) rotate(0deg);
    }
  
    100% {
      transform: translate(1px, -2px) rotate(-1deg);
    }
  }
  
  .cursor-point {
    cursor: pointer;
  }

  .shadow {
    /* width: 98%; */
    /* box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px; */
    margin-bottom: 50px;
    box-shadow: rgba(17, 17, 26, 0.1) 0px 4px 16px, rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px;
    /* box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px; */
    border-radius: 15px;
    padding-top:30px;
    padding-bottom: 30px 
  }

  .title-shadow{
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    border-radius: 8px;
    padding: 8px;
    margin-top:5px;
  }`, "",{"version":3,"sources":["webpack://./src/app/add-new/add-new.component.css"],"names":[],"mappings":"AAAA;IACI,oDAAoD;AACxD;;;;AAIA;IACI,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,WAAW;IACX,mBAAmB;EACrB;;;EAGA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,UAAU;EACZ;;EAEA;IACE;MACE,UAAU;IACZ;;EAEF;;EAEA;IACE,UAAU;IACV,sBAAsB;IACtB,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,0BAA0B;IAC1B,kBAAkB;IAClB,cAAc;IACd;EACF;;;;;EAKA;IACE,UAAU;IACV,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,MAAM;IACN,OAAO;IACP,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,8DAA8D;IAC9D,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,iDAAiD;EACnD;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;;EAGA;IACE,mBAAmB;IACnB,kCAAkC;EACpC;;EAEA;IACE,UAAU;IACV,aAAa;IACb,iDAAiD;IACjD,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB;EACF;;;EAGA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;EACX;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;IACT,sBAAsB;EACxB;;EAEA;IACE;EACF;;EAEA;IACE,IAAI,UAAU;IACd,MAAM,UAAU;EAClB;;EAEA;IACE;MACE,2CAA2C;IAC7C;;IAEA;MACE,8CAA8C;IAChD;;IAEA;MACE,4CAA4C;IAC9C;;IAEA;MACE,2CAA2C;IAC7C;;IAEA;MACE,4CAA4C;IAC9C;;IAEA;MACE,6CAA6C;IAC/C;;IAEA;MACE,4CAA4C;IAC9C;;IAEA;MACE,4CAA4C;IAC9C;;IAEA;MACE,6CAA6C;IAC/C;;IAEA;MACE,2CAA2C;IAC7C;;IAEA;MACE,6CAA6C;IAC/C;EACF;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,uDAAuD;IACvD,mBAAmB;IACnB,uHAAuH;IACvH,+FAA+F;IAC/F,mBAAmB;IACnB,gBAAgB;IAChB;EACF;;EAEA;IACE,iDAAiD;IACjD,kBAAkB;IAClB,YAAY;IACZ,cAAc;EAChB","sourcesContent":["* {\n    font-family: Arial, Helvetica, sans-serif !important;\n}\n\n\n\n.rowcenter {\n    margin-top: 30px;\n    display: flex;\n    justify-content: center;\n    align-items: flex-start;\n    width: 100%;\n    flex-direction: row;\n  }\n  \n  \n  .dropzone-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    width: 40%;\n  }\n\n  @media screen and (max-width: 600px) {\n    .dropzone-container { \n      width: 48%;\n    }\n   \n  }\n  \n  .dropzone {\n    width: 90%;\n    /* min-width: 250px; */\n    cursor: pointer;\n    /* height: 220px; */\n    padding: 1rem;\n    text-align: center;\n    border-radius: 20px;\n    border: dashed 1px #979797;\n    position: relative;\n    margin: 0 auto;\n    box-shadow: 1px 1px 2px rgba(255, 255, 255, .6)\n  }\n  \n  \n  \n  \n  .dropzone input {\n    opacity: 0;\n    position: absolute;\n    z-index: 2;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    cursor: pointer;\n  }\n  \n  ul {\n    padding: 0px;\n    margin: 0px;\n  }\n  \n  .dropzone label {\n    color: white;\n    background-image: linear-gradient(to right, #77A1D3, #79CBCA );\n    height: 32px;\n    width: 150px;\n    border-radius: 20px;\n    padding: 4px 8px;\n    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 2px 0px;\n  }\n  \n  .dropzone h5 {\n    color: #aaabad;\n    font-weight: 700;\n  }\n  \n  \n  .fileover {\n    animation: shake 1s;\n    animation-iteration-count:infinite;\n  }\n  \n  .file-list {\n    width: 80%;\n    display: flex;\n    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    margin-top: 15px;\n    border-radius: 10px;\n    padding: 5px\n  }\n  \n  \n  .name {\n    font-size: 14px;\n    font-weight: 500;\n    color: #353f4a;\n    margin: 0;\n  }\n  \n  .size {\n    font-size: 12px;\n    font-weight: 500;\n    color: #a4a4a4;\n    margin: 0;\n    margin-bottom: 0.25rem;\n  }\n  \n  .info {\n    width: 100%\n  }\n  \n  @keyframes extend {\n    0% {width: 75%}\n    100% {width: 90%}\n  }\n  \n  @keyframes shake {\n    0% {\n      transform: translate(1px, 1px) rotate(0deg);\n    }\n  \n    10% {\n      transform: translate(-1px, -2px) rotate(-1deg);\n    }\n  \n    20% {\n      transform: translate(-3px, 0px) rotate(1deg);\n    }\n  \n    30% {\n      transform: translate(3px, 2px) rotate(0deg);\n    }\n  \n    40% {\n      transform: translate(1px, -1px) rotate(1deg);\n    }\n  \n    50% {\n      transform: translate(-1px, 2px) rotate(-1deg);\n    }\n  \n    60% {\n      transform: translate(-3px, 1px) rotate(0deg);\n    }\n  \n    70% {\n      transform: translate(3px, 1px) rotate(-1deg);\n    }\n  \n    80% {\n      transform: translate(-1px, -1px) rotate(1deg);\n    }\n  \n    90% {\n      transform: translate(1px, 2px) rotate(0deg);\n    }\n  \n    100% {\n      transform: translate(1px, -2px) rotate(-1deg);\n    }\n  }\n  \n  .cursor-point {\n    cursor: pointer;\n  }\n\n  .shadow {\n    /* width: 98%; */\n    /* box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px; */\n    margin-bottom: 50px;\n    box-shadow: rgba(17, 17, 26, 0.1) 0px 4px 16px, rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px;\n    /* box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px; */\n    border-radius: 15px;\n    padding-top:30px;\n    padding-bottom: 30px \n  }\n\n  .title-shadow{\n    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\n    border-radius: 8px;\n    padding: 8px;\n    margin-top:5px;\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
